module.exports = __webpack_public_path__ + "img/88.bb405385.jpg";